import { render, staticRenderFns } from "./QuestionsResult.vue?vue&type=template&id=4a740d64&scoped=true&"
import script from "./QuestionsResult.vue?vue&type=script&lang=js&"
export * from "./QuestionsResult.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsResult.vue?vue&type=style&index=0&id=4a740d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a740d64",
  null
  
)

export default component.exports